export const sampleMode = {
    labRequest: "labRequest",
    sample: "sample",
}; 